<template>
  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" class="informer_close">
    <path d="M19.8333 11.3333H11.3333V19.8333H8.5V11.3333H0V8.5H8.5V0H11.3333V8.5H19.8333V11.3333Z" transform="translate(-5.12549 9.00098) rotate(-45)" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'icon-close',
    props: {
      fill: {
        type: String,
        default: 'currentColor'
      }
    }
  }
</script>
